import { render, staticRenderFns } from "./HomeSupervise.vue?vue&type=template&id=c31152c0&scoped=true&"
import script from "./HomeSupervise.vue?vue&type=script&lang=js&"
export * from "./HomeSupervise.vue?vue&type=script&lang=js&"
import style0 from "./HomeSupervise.vue?vue&type=style&index=0&id=c31152c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31152c0",
  null
  
)

export default component.exports